"use client";

import styled from "styled-components";
import { ReactNode } from "react";

interface IWarningModal {
  toggleModal: () => void;
  content: ReactNode;
  modalWidth?: string;
}

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div<{ $modalWidth?: string }>`
  background-color: ${(props) => props.theme.white};
  border-radius: 10px;
  padding: 20px;
  width: ${(props) => props.$modalWidth || "50%"};
  max-width: 90vw;
  max-height: 90vh;

  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const ModalContent = styled.div`
  width: 100%;
`;

export default function WarningModal({
  toggleModal,
  content,
  modalWidth,
}: IWarningModal) {
  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      toggleModal();
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContainer $modalWidth={modalWidth}>
        <ModalContent>{content}</ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
}
